<template>
  <div v-wechat-title="titleTop">
    <div class="bodyRect">{{ aboutStr }}</div>
    <followWx v-model="showFollow" @finish="onFollowFinish" />
    <followWxInfo v-model="showFollowInfo" @finish="onFollowFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import { MyNotify, ShowMoney, GetEnumText, formatDate, getUrlKey } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import followWx from '@/components/followWx'
import followWxInfo from '@/components/followWxInfo'
import { getUserBase } from '@/utils/base'

export default {
  components: {
    [Button.name]: Button,
    followWx,
    followWxInfo
  },
  data() {
    return {
      titleTop: '酷潜潜水',
      backurl: '/store/index',
      showFollow: false,
      showFollowInfo: false,
      uId: ' ',
      groupkey: '',
      aboutStr: '',
      finishNativeUrl: undefined
    }
  },

  created() {
    this.uId = getUrlKey('uid')
    this.groupkey = getUrlKey('groupkey')
    if (this.uId) {
      this.aboutStr = '加载中......'
      getUserBase(data => {
        this.titleTop = GetSysTitle()
        setTimeout(() => {
          this.showFollowInfo = true
        }, 100)
      })
    } else {
      this.aboutStr = '推荐人不存在'
    }
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/Activity/relationshipUser',
        method: 'post',
        data: {
          userId: this.uId,
          groupKey: this.groupkey
        }
      }).then(response => {
        if (!response.success) {
          this.finishNativeUrl = undefined
        } else {
          this.finishNativeUrl = response.data.nativeUrl
          if (!response.data.bindFinish) {
            MyNotify('error', response.data.errorMessage)
          }
        }
        if (callback) {
          callback()
        }
      })
    },
    onFollowFinish() {
      this.init(() => {
        if (this.finishNativeUrl) {
          if (this.finishNativeUrl.startsWith('/')) {
            this.$router.push(this.finishNativeUrl)
          } else {
            window.location.href = this.finishNativeUrl
          }
        } else {
          this.$router.push('/store/index')
        }
      })

      // window.location.href = 'https://mp.weixin.qq.com/s/ALq7_ZJeDg9KXssSnKBAdA'
      // window.location.href = 'https://mp.weixin.qq.com/s/ALq7_ZJeDg9KXssSnKBAdA'  //寻找美人鱼
      // window.location.href = 'http://qr61.cn/o54eFo/q3z9h9y'   //美人鱼教练计划
    }
  }
}
</script>
<style scoped>
.bodyRect{
    padding: 15em 1em;
    text-align: center;
    color: #999;
    font-size: 0.8em;
}
</style>
